"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParsedType = exports.ZodParsedType = exports.objectUtil = exports.util = void 0;
var util;

(function (util) {
  util.assertEqual = function (val) {
    return val;
  };

  function assertIs(_arg) {}

  util.assertIs = assertIs;

  function assertNever(_x) {
    throw new Error();
  }

  util.assertNever = assertNever;

  util.arrayToEnum = function (items) {
    var obj = {};

    var _iterator = _createForOfIteratorHelper(items),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        obj[item] = item;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return obj;
  };

  util.getValidEnumValues = function (obj) {
    var validKeys = util.objectKeys(obj).filter(function (k) {
      return typeof obj[obj[k]] !== "number";
    });
    var filtered = {};

    var _iterator2 = _createForOfIteratorHelper(validKeys),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var k = _step2.value;
        filtered[k] = obj[k];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return util.objectValues(filtered);
  };

  util.objectValues = function (obj) {
    return util.objectKeys(obj).map(function (e) {
      return obj[e];
    });
  };

  util.objectKeys = typeof Object.keys === "function" ? function (obj) {
    return Object.keys(obj);
  } : function (object) {
    var keys = [];

    for (var key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        keys.push(key);
      }
    }

    return keys;
  };

  util.find = function (arr, checker) {
    var _iterator3 = _createForOfIteratorHelper(arr),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var item = _step3.value;
        if (checker(item)) return item;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return undefined;
  };

  util.isInteger = typeof Number.isInteger === "function" ? function (val) {
    return Number.isInteger(val);
  } : function (val) {
    return typeof val === "number" && isFinite(val) && Math.floor(val) === val;
  };

  function joinValues(array) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " | ";
    return array.map(function (val) {
      return typeof val === "string" ? "'".concat(val, "'") : val;
    }).join(separator);
  }

  util.joinValues = joinValues;

  util.jsonStringifyReplacer = function (_, value) {
    if (typeof value === "bigint") {
      return value.toString();
    }

    return value;
  };
})(util = exports.util || (exports.util = {}));

var objectUtil;

(function (objectUtil) {
  objectUtil.mergeShapes = function (first, second) {
    return _objectSpread(_objectSpread({}, first), second);
  };
})(objectUtil = exports.objectUtil || (exports.objectUtil = {}));

exports.ZodParsedType = util.arrayToEnum(["string", "nan", "number", "integer", "float", "boolean", "date", "bigint", "symbol", "function", "undefined", "null", "array", "object", "unknown", "promise", "void", "never", "map", "set"]);

var getParsedType = function getParsedType(data) {
  var t = typeof data;

  switch (t) {
    case "undefined":
      return exports.ZodParsedType.undefined;

    case "string":
      return exports.ZodParsedType.string;

    case "number":
      return isNaN(data) ? exports.ZodParsedType.nan : exports.ZodParsedType.number;

    case "boolean":
      return exports.ZodParsedType.boolean;

    case "function":
      return exports.ZodParsedType.function;

    case "bigint":
      return exports.ZodParsedType.bigint;

    case "symbol":
      return exports.ZodParsedType.symbol;

    case "object":
      if (Array.isArray(data)) {
        return exports.ZodParsedType.array;
      }

      if (data === null) {
        return exports.ZodParsedType.null;
      }

      if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
        return exports.ZodParsedType.promise;
      }

      if (typeof Map !== "undefined" && data instanceof Map) {
        return exports.ZodParsedType.map;
      }

      if (typeof Set !== "undefined" && data instanceof Set) {
        return exports.ZodParsedType.set;
      }

      if (typeof Date !== "undefined" && data instanceof Date) {
        return exports.ZodParsedType.date;
      }

      return exports.ZodParsedType.object;

    default:
      return exports.ZodParsedType.unknown;
  }
};

exports.getParsedType = getParsedType;